import { Component, OnInit, AfterViewInit, ChangeDetectorRef, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { CarService } from 'src/app/services/car/car.service';
import { GeneralService } from 'src/app/services/general/general.service';
import { VehicleModalService } from 'src/app/services/vehicle-modal/vehicle-modal.service';
import { PaginatedResponse, PaginationInfo } from 'src/app/shared/models';
import { VehicleService } from 'src/app/services/vehicle/vehicle.service';
import { MashoManagerModalService } from 'src/app/services/masho-manager-modal/masho-manager-modal.service';
import { TransportPickupModalService } from 'src/app/services/transport-pickup-modal/transport-pickup-modal.service';
import { PurchaseManagerModalService } from 'src/app/services/purchase-manager-modal/purchase-manager-modal.service';
import { CarMakerService } from 'src/app/services/car-maker/car-maker.service';
import { CarModelService } from 'src/app/services/car-model/car-model.service';
import { ModelCodeService } from 'src/app/services/model-code/model-code.service';
import { FuelService } from 'src/app/services/fuel/fuel.service';
import { TransmissionService } from 'src/app/services/transmission/transmission.service';
import { BodyColorService } from 'src/app/services/body-color/body-color.service';
import { ClientService } from 'src/app/services/user/client.service';
import { UserService } from 'src/app/services/user/user.service';
import { ShipService } from 'src/app/services/ship/ship.service';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import Swal from 'sweetalert2';

declare var bootstrap: any;
declare var KTMenu: any;

@Component({
  selector: 'app-vh-manager-listing',
  templateUrl: './vh-manager-listing.component.html',
  styleUrls: ['./vh-manager-listing.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ height: '0px', opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-in-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('300ms ease-in-out', style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class VhManagerListingComponent extends DestructorComponent implements OnInit, AfterViewInit {

  @Output() vehicleUpdated = new EventEmitter<void>();

  // Expose Math to template
  Math = Math;

  loggedInUser:any;

  // Data properties
  vehicles: any[] = [];
  paginationInfo: PaginationInfo = {
    currentPage: 1,
    perPage: 20,
    total: 0,
    lastPage: 1,
    firstPage: 1
  };

  // State properties
  isLoading: boolean = false;
  searchTerm: string = '';
  currentPage: number = 1;
  showFiltersForm = false;

  // Filter properties
  filters = {
    search: '',
    make: '',
    model: '',
    model_code: '',
    year_from: '',
    year_to: '',
    price_from: '',
    price_to: '',
    mileage_from: '',
    mileage_to: '',
    engine_cc: '',
    fuel_type: '',
    transmission: '',
    steering: '',
    color: '',
    one_price_data: '',
    source: '',
    keyword: '',
    stock_number: '',
    sold_to: '',
    purchase_from: '',
    sales_person: '',
    status: '',
    display: '',
    yard_in_date_from: '',
    yard_in_date_to: '',
    location: '',
    date_from: '',
    date_to: '',
    etd_from: '',
    etd_to: '',
    eta_from: '',
    eta_to: '',
    ship_name_id: ''
  };

  // Dropdown data
  makesList: any[] = [];
  modelsList: any[] = [];
  modelCodesList: any[] = [];
  fuelTypesList: any[] = [];
  transmissionList: any[] = [];
  colorsList: any[] = [];

  // Year options
  yearOptions: any[] = [];

  // Mileage options
  mileageOptions = [
    { value: '10000', label: '10,000 km' },
    { value: '20000', label: '20,000 km' },
    { value: '30000', label: '30,000 km' },
    { value: '40000', label: '40,000 km' },
    { value: '50000', label: '50,000 km' },
    { value: '50000+', label: 'Above 50,000 km' }
  ];

  // Engine CC options
  engineCCOptions = [
    { value: '660', label: '660cc' },
    { value: '1000', label: '1000cc' },
    { value: '1300', label: '1300cc' },
    { value: '1500', label: '1500cc' },
    { value: '1800', label: '1800cc' },
    { value: '2000', label: '2000cc' },
    { value: '2500', label: '2500cc' },
    { value: '3000', label: '3000cc' },
    { value: '3500', label: '3500cc' },
    { value: '4000', label: '4000cc' },
    { value: '4000+', label: 'Above 4000cc' }
  ];

  // Steering options
  steeringOptions = [
    { value: 'left', label: 'Left Hand Drive' },
    { value: 'right', label: 'Right Hand Drive' }
  ];

  // One Price Data options (dummy)
  onePriceDataOptions = [
    { value: 'available', label: 'Available' },
    { value: 'not_available', label: 'Not Available' }
  ];

  // Source options (dummy)
  sourceOptions = [
    { value: 'auction', label: 'Auction' },
    { value: 'dealer', label: 'Dealer' },
    { value: 'private', label: 'Private' },
    { value: 'import', label: 'Import' }
  ];

  // Status options
  statusOptions = [
    { value: 'sold', label: 'Sold' },
    { value: 'not_sold', label: 'Not Sold' }
  ];

  // Display options
  displayOptions = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'In Active' }
  ];

  // Searchable input properties for Sold To
  soldToSearchTerm: string = '';
  selectedSoldTo: any = null;
  soldToSearchResults: any[] = [];
  showSoldToDropdown: boolean = false;
  isSoldToSearching: boolean = false;
  private soldToSearchSubject = new Subject<string>();

  // Searchable input properties for Purchase From
  purchaseFromSearchTerm: string = '';
  selectedPurchaseFrom: any = null;
  purchaseFromSearchResults: any[] = [];
  showPurchaseFromDropdown: boolean = false;
  isPurchaseFromSearching: boolean = false;
  private purchaseFromSearchSubject = new Subject<string>();

  // Searchable input properties for Sales Person
  salesPersonSearchTerm: string = '';
  selectedSalesPerson: any = null;
  salesPersonSearchResults: any[] = [];
  showSalesPersonDropdown: boolean = false;
  isSalesPersonSearching: boolean = false;
  private salesPersonSearchSubject = new Subject<string>();

  // Searchable input properties for Ship Name
  shipSearchTerm: string = '';
  selectedShip: any = null;
  shipSearchResults: any[] = [];
  showShipDropdown: boolean = false;
  isShipSearching: boolean = false;
  private shipSearchSubject = new Subject<string>();

  constructor(
    private _carService: CarService,
    private _vehicleService: VehicleService,
    private _generalService: GeneralService,
    private _vehicleModalService: VehicleModalService,
    private _mashoManagerModalService: MashoManagerModalService,
    private _transportPickupModalService: TransportPickupModalService,
    private _purchaseManagerModalService: PurchaseManagerModalService,
    private _carMakerService: CarMakerService,
    private _carModelService: CarModelService,
    private _modelCodeService: ModelCodeService,
    private _fuelService: FuelService,
    private _transmissionService: TransmissionService,
    private _bodyColorService: BodyColorService,
    private _globalStateService: GlobalStateService,
    private _clientService: ClientService,
    private _userService: UserService,
    private _shipService: ShipService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    super();
    this.setupSoldToSearchDebounce();
    this.setupPurchaseFromSearchDebounce();
    this.setupSalesPersonSearchDebounce();
    this.setupShipSearchDebounce();
    this.generateYearOptions();
  }

  ngOnInit(): void {
    this.loadVehicles();
    this.loadMakes();
    this.loadFuelTypes();
    this.loadTransmissions();
    this.loadColors();
    this.setupModalSubscriptions();
    this.setLoggedInUser()
  }

  setLoggedInUser(): void {
    this.subscriptions.push(
      this._globalStateService.user.subscribe(user => {
        this.loggedInUser = user;
      })
    )
  }

  ngAfterViewInit(): void {
    this.refreshMenus();
  }

  private setupModalSubscriptions(): void {
    // Listen for vehicle updates
    this.subscriptions.push(
      this._vehicleModalService.selectedVehicle$.subscribe(vehicle => {
        if (vehicle) {
          // Vehicle selected for editing
        }
      })
    );
  }

  private refreshMenus(): void {
    setTimeout(() => {
      if (typeof KTMenu !== 'undefined') {
        KTMenu.createInstances();
      }
    }, 100);
  }

  private resetPagination(): void {
    this.paginationInfo = {
      currentPage: 1,
      perPage: 20,
      total: 0,
      lastPage: 1,
      firstPage: 1
    };
  }

  loadVehicles(page: number = 1, search: string = '', filters: Record<string, any> = {}): void {
    this.isLoading = true;
    filters.panel_filters = "true"
    for(const key in filters) {
      if (filters[key] === '' || filters[key] === null) {
        delete filters[key];
      }
    }
    this.subscriptions.push(
      this._vehicleService.GetData(page.toString(), search, filters).subscribe({
        next: (response: PaginatedResponse<any>) => {
          if (response.status && response.data) {
            this.vehicles = response.data.data || [];
            this.paginationInfo = response.data.pagination;
            this.currentPage = response.data.pagination.currentPage;
          } else {
            this.vehicles = [];
            this.resetPagination();
          }
          this.isLoading = false;
          this.cdr.detectChanges();
          this.refreshMenus();
        },
        error: (error) => {
          console.error('Error loading vehicles:', error);
          this.vehicles = [];
          this.resetPagination();
          this.isLoading = false;
          this.cdr.detectChanges();
          this.refreshMenus();
        }
      })
    );
  }

  onPageChange(page: number): void {
    this.loadVehicles(page, this.searchTerm, this.filters);
  }

  toggleFilters(): void {
    this.showFiltersForm = !this.showFiltersForm;
  }

  applyFilters(): void {
    this.filters.search = this.searchTerm;
    console.log('Applied filters:', this.filters);
    this.loadVehicles(1, this.searchTerm, this.filters);
  }

  clearFilters(): void {
    this.filters = {
      search: '',
      make: '',
      model: '',
      model_code: '',
      year_from: '',
      year_to: '',
      price_from: '',
      price_to: '',
      mileage_from: '',
      mileage_to: '',
      engine_cc: '',
      fuel_type: '',
      transmission: '',
      steering: '',
      color: '',
      one_price_data: '',
      source: '',
      keyword: '',
      stock_number: '',
      sold_to: '',
      purchase_from: '',
      sales_person: '',
      status: '',
      display: '',
      yard_in_date_from: '',
      yard_in_date_to: '',
      location: '',
      date_from: '',
      date_to: '',
      etd_from: '',
      etd_to: '',
      eta_from: '',
      eta_to: '',
      ship_name_id: ''
    };
    this.searchTerm = '';
    this.modelsList = [];
    this.clearSoldToSearch();
    this.clearPurchaseFromSearch();
    this.clearSalesPersonSearch();
    this.clearShipSearch();
    this.loadVehicles(1, '', {});
  }

  loadMakes(): void {
    this.subscriptions.push(
      this._generalService.GetMakes().subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.makesList = response.data.map((make: any) => ({
              value: make.slug || make._id,
              label: make.name
            }));
          }
        },
        error: (error: any) => {
          console.error('Error loading makes:', error);
        }
      })
    );
  }

  onMakeChange(makeSlug: string): void {
    this.filters.model = '';
    this.filters.model_code = '';
    this.modelsList = [];
    this.modelCodesList = [];
    if (makeSlug) {
      this.loadModels(makeSlug);
    }
  }

  onMakeSelectionChange(makeSlug: string | null): void {
    this.filters.make = makeSlug || '';
    this.onMakeChange(makeSlug || '');
  }

  onModelChange(modelSlug: string): void {
    this.filters.model_code = '';
    this.modelCodesList = [];
    if (modelSlug) {
      this.loadModelCodes(modelSlug);
    }
  }

  onModelSelectionChange(modelSlug: string | null): void {
    this.filters.model = modelSlug || '';
    this.onModelChange(modelSlug || '');
  }

  loadModels(makeSlug: string): void {
    if (!makeSlug) {
      this.modelsList = [];
      return;
    }

    this.subscriptions.push(
      this._generalService.GetModels(makeSlug).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.modelsList = response.data.map((model: any) => ({
              value: model.slug || model._id,
              label: model.name
            }));
          }
        },
        error: (error: any) => {
          console.error('Error loading models:', error);
          this.modelsList = [];
        }
      })
    );
  }

  editVehicle(vehicle: any): void {
    if (vehicle && vehicle._id) {
      this.router.navigate(['/vehicles/vehicle-manager/edit', vehicle._id]);
    }
  }

  viewVehicleDetails(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Navigate to vehicle details view or open modal
      this.router.navigate(['/vehicles/vehicle-details', vehicle._id]);
    }
  }

  uploadDocuments(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Set the selected vehicle for the modal
      this.setSelectedVehicleForModal(vehicle);

      // Open the document upload modal
      const modalElement = document.getElementById('kt_modal_vehicle_upload_documents');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  private setSelectedVehicleForModal(vehicle: any): void {
    // You can use a service to pass the vehicle data to the modal
    // For now, we'll store it in a way the modal can access it
    (window as any).selectedVehicleForDocuments = vehicle;
  }

  onDocumentsUploaded(): void {
    // Reload the vehicles listing to reflect any changes
    this.loadVehicles(this.currentPage, this.searchTerm, this.filters);
  }

  onImagesUploaded(): void {
    // Reload the vehicles listing to reflect any changes
    this.loadVehicles(this.currentPage, this.searchTerm, this.filters);
  }

  transportPickup(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Set the pre-selected vehicle in the modal service
      this._transportPickupModalService.setPreSelectedVehicle(vehicle);

      // Open the transport pickup add/edit modal
      const modalElement = document.getElementById('kt_modal_transport_pickup_add_edit');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  exportVehicle(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Implement export functionality
      console.log('Exporting vehicle:', vehicle);
      // You can implement PDF export, Excel export, etc.
    }
  }

  purchaseManager(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Set the pre-selected vehicle in the modal service
      this._purchaseManagerModalService.setPreSelectedVehicle(vehicle);

      // Open the purchase manager add/edit modal
      const modalElement = document.getElementById('kt_modal_purchase_manager_add_edit');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  exportCertificate(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Set the selected vehicle for the modal
      this._vehicleModalService.setSelectedVehicle(vehicle);

      // Open the export certificate modal
      const modalElement = document.getElementById('kt_modal_vh_manager_export_certificate');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  inspection(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Navigate to inspection page
      console.log('Inspection for vehicle:', vehicle);
      // this.router.navigate(['/vehicles/inspection', vehicle._id]);
    }
  }

  vesselTimeSheet(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Navigate to vessel time sheet
      console.log('Vessel time sheet for vehicle:', vehicle);
      // this.router.navigate(['/vehicles/vessel-time-sheet', vehicle._id]);
    }
  }

  vehiclePriceSheet(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Set the selected vehicle for the modal
      (window as any).selectedVehicleForPriceSheet = vehicle;

      // Open the vehicle price sheet modal
      const modalElement = document.getElementById('kt_modal_vh_price_sheet');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  vehicleReceipt(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Generate vehicle receipt
      console.log('Vehicle receipt for vehicle:', vehicle);
      // Implement receipt generation
    }
  }

  uploadImages(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Set the selected vehicle for the modal
      (window as any).selectedVehicleForImageUpload = vehicle;

      // Open the image upload modal
      const modalElement = document.getElementById('kt_modal_vh_manager_upload_images');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  mashoManage(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Set the pre-selected vehicle in the modal service
      this._mashoManagerModalService.setPreSelectedVehicle(vehicle);

      // Open the masho manager add/edit modal
      const modalElement = document.getElementById('kt_modal_masho_manager_add_edit');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  vehicleRemark(vehicle: any): void {
    if (vehicle && vehicle._id) {
      // Set the selected vehicle for the modal
      (window as any).selectedVehicleForRemarks = vehicle;

      // Open the vehicle remarks modal
      const modalElement = document.getElementById('kt_modal_vehicle_remarks');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  removeStock(vehicle: any): void {
    if (vehicle && vehicle._id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to remove this vehicle from stock? This action cannot be undone!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, remove it!',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          this.subscriptions.push(
            this._vehicleService.DeleteDataById(vehicle._id).subscribe({
              next: (response: any) => {
                if (response.status) {
                  Swal.fire({
                    title: 'Removed!',
                    text: 'Vehicle has been removed from stock successfully.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                  }).then(() => {
                    // Reload the vehicles list
                    this.loadVehicles(this.currentPage, this.searchTerm, this.filters);
                  });
                } else {
                  Swal.fire({
                    title: 'Error!',
                    text: response.message || 'Failed to remove vehicle from stock.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                  });
                }
              },
              error: (error) => {
                console.error('Error removing vehicle:', error);
                Swal.fire({
                  title: 'Error!',
                  text: error.error?.message || 'An error occurred while removing the vehicle.',
                  icon: 'error',
                  confirmButtonText: 'OK'
                });
              }
            })
          );
        }
      });
    }
  }

  trackByFn(index: number, item: any): any {
    return item._id || index;
  }

  formatPrice(price: number): string {
    if (!price) return '-';
    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY',
      minimumFractionDigits: 0
    }).format(price);
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      });
    } catch {
      return dateString;
    }
  }

  getVehicleImageUrl(vehicle: any): string | null {
    if (vehicle.pictures && vehicle.pictures.length > 0) {
      return vehicle.type == "alaedo" ? vehicle.pictures[vehicle.pictures.length - 1] : vehicle.pictures[0];
    }
    return null;
  }

  hasVehicleImage(vehicle: any): boolean {
    return vehicle.pictures && vehicle.pictures.length > 0;
  }

  // Generate year options from 1990 to current year
  generateYearOptions(): void {
    const currentYear = new Date().getFullYear();
    this.yearOptions = [];
    for (let year = currentYear; year >= currentYear; year--) {
      this.yearOptions.push({ value: year.toString(), label: year.toString() });
    }
  }

  // Load model codes
  loadModelCodes(modelSlug?: string): void {
    if (!modelSlug) {
      this.modelCodesList = [];
      return;
    }

    this.subscriptions.push(
      this._modelCodeService.GetData('1', '', { paginate: false, model_slug: modelSlug }).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            const modelCodes = Array.isArray(response.data) ? response.data : response.data.data || [];
            this.modelCodesList = modelCodes.map((modelCode: any) => ({
              value: modelCode._id,
              label: modelCode.code || modelCode.name
            }));
          }
        },
        error: (error: any) => {
          console.error('Error loading model codes:', error);
          this.modelCodesList = [];
        }
      })
    );
  }

  // Load fuel types
  loadFuelTypes(): void {
    this.subscriptions.push(
      this._fuelService.GetData('1', '', { paginate: false }).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.fuelTypesList = response.data?.map((fuel: any) => ({
              value: fuel.slug,
              label: fuel.name
            })) || [];
          }
        },
        error: (error: any) => {
          console.error('Error loading fuel types:', error);
        }
      })
    );
  }

  // Load transmissions
  loadTransmissions(): void {
    this.subscriptions.push(
      this._transmissionService.GetData('1', '', { paginate: false }).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.transmissionList = response.data?.map((transmission: any) => ({
              value: transmission.slug,
              label: transmission.name
            })) || [];
          }
        },
        error: (error: any) => {
          console.error('Error loading transmissions:', error);
        }
      })
    );
  }

  // Load colors
  loadColors(): void {
    this.subscriptions.push(
      this._bodyColorService.GetData('1', '', { paginate: false }).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.colorsList = response.data?.map((color: any) => ({
              value: color.slug,
              label: color.name
            })) || [];
          }
        },
        error: (error: any) => {
          console.error('Error loading colors:', error);
        }
      })
    );
  }

  // Setup search debounce methods
  private setupSoldToSearchDebounce(): void {
    this.soldToSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.searchSoldTo(searchTerm);
    });
  }

  private setupPurchaseFromSearchDebounce(): void {
    this.purchaseFromSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.searchPurchaseFrom(searchTerm);
    });
  }

  private setupSalesPersonSearchDebounce(): void {
    this.salesPersonSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.searchSalesPersons(searchTerm);
    });
  }

  // Sold To search methods
  onSoldToSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.soldToSearchTerm = target.value;
    this.selectedSoldTo = null;
    this.soldToSearchSubject.next(this.soldToSearchTerm);
    this.showSoldToDropdown = true;
  }

  onSoldToInputFocus(): void {
    if (this.soldToSearchResults.length > 0) {
      this.showSoldToDropdown = true;
    }
  }

  onSoldToInputBlur(): void {
    setTimeout(() => {
      this.showSoldToDropdown = false;
    }, 200);
  }

  private searchSoldTo(searchTerm: string): void {
    if (!searchTerm || searchTerm.length < 2) {
      this.soldToSearchResults = [];
      this.showSoldToDropdown = false;
      return;
    }

    this.isSoldToSearching = true;
    this.subscriptions.push(
      this._clientService.GetData('1', searchTerm).subscribe({
        next: (response: any) => {
          this.isSoldToSearching = false;
          if (response.status && response.data && response.data.data) {
            this.soldToSearchResults = response.data.data;
            this.showSoldToDropdown = this.soldToSearchResults.length > 0;
          } else {
            this.soldToSearchResults = [];
            this.showSoldToDropdown = false;
          }
        },
        error: (error: any) => {
          this.isSoldToSearching = false;
          console.error('Error searching sold to:', error);
          this.soldToSearchResults = [];
          this.showSoldToDropdown = false;
        }
      })
    );
  }

  selectSoldTo(soldTo: any): void {
    this.selectedSoldTo = soldTo;
    this.soldToSearchTerm = this.getSoldToDisplayName(soldTo);
    this.showSoldToDropdown = false;
    this.soldToSearchResults = [];
    this.filters.sold_to = soldTo._id;
  }

  clearSoldToSearch(): void {
    this.soldToSearchTerm = '';
    this.selectedSoldTo = null;
    this.showSoldToDropdown = false;
    this.soldToSearchResults = [];
    this.filters.sold_to = '';
  }

  getSoldToDisplayName(soldTo: any): string {
    if (soldTo.name && soldTo.company) {
      return `${soldTo.name}, ${soldTo.company}`;
    }
    return `${soldTo.name || ''} ${soldTo.last_name || ''}`.trim() || soldTo.email || 'Unknown Customer';
  }

  // Purchase From search methods
  onPurchaseFromSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.purchaseFromSearchTerm = target.value;
    this.selectedPurchaseFrom = null;
    this.purchaseFromSearchSubject.next(this.purchaseFromSearchTerm);
    this.showPurchaseFromDropdown = true;
  }

  onPurchaseFromInputFocus(): void {
    if (this.purchaseFromSearchResults.length > 0) {
      this.showPurchaseFromDropdown = true;
    }
  }

  onPurchaseFromInputBlur(): void {
    setTimeout(() => {
      this.showPurchaseFromDropdown = false;
    }, 200);
  }

  private searchPurchaseFrom(searchTerm: string): void {
    if (!searchTerm || searchTerm.length < 2) {
      this.purchaseFromSearchResults = [];
      this.showPurchaseFromDropdown = false;
      return;
    }

    this.isPurchaseFromSearching = true;
    this.subscriptions.push(
      this._userService.GetData('1', searchTerm, { is_primary_agent: true }).subscribe({
        next: (response: any) => {
          this.isPurchaseFromSearching = false;
          if (response.status && response.data && response.data.data) {
            this.purchaseFromSearchResults = response.data.data;
            this.showPurchaseFromDropdown = this.purchaseFromSearchResults.length > 0;
          } else {
            this.purchaseFromSearchResults = [];
            this.showPurchaseFromDropdown = false;
          }
        },
        error: (error: any) => {
          this.isPurchaseFromSearching = false;
          console.error('Error searching purchase from:', error);
          this.purchaseFromSearchResults = [];
          this.showPurchaseFromDropdown = false;
        }
      })
    );
  }

  selectPurchaseFrom(purchaseFrom: any): void {
    this.selectedPurchaseFrom = purchaseFrom;
    this.purchaseFromSearchTerm = this.getPurchaseFromDisplayName(purchaseFrom);
    this.showPurchaseFromDropdown = false;
    this.purchaseFromSearchResults = [];
    this.filters.purchase_from = purchaseFrom._id;
  }

  clearPurchaseFromSearch(): void {
    this.purchaseFromSearchTerm = '';
    this.selectedPurchaseFrom = null;
    this.showPurchaseFromDropdown = false;
    this.purchaseFromSearchResults = [];
    this.filters.purchase_from = '';
  }

  getPurchaseFromDisplayName(purchaseFrom: any): string {
    if (purchaseFrom.name && purchaseFrom.company) {
      return `${purchaseFrom.name}, ${purchaseFrom.company}`;
    }
    return `${purchaseFrom.name || ''} ${purchaseFrom.last_name || ''}`.trim() || purchaseFrom.email || 'Unknown User';
  }

  // Sales Person search methods
  onSalesPersonSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.salesPersonSearchTerm = target.value;
    this.selectedSalesPerson = null;
    this.salesPersonSearchSubject.next(this.salesPersonSearchTerm);
    this.showSalesPersonDropdown = true;
  }

  onSalesPersonInputFocus(): void {
    if (this.salesPersonSearchResults.length > 0) {
      this.showSalesPersonDropdown = true;
    }
  }

  onSalesPersonInputBlur(): void {
    setTimeout(() => {
      this.showSalesPersonDropdown = false;
    }, 200);
  }

  private searchSalesPersons(searchTerm: string): void {
    if (!searchTerm || searchTerm.length < 2) {
      this.salesPersonSearchResults = [];
      this.showSalesPersonDropdown = false;
      return;
    }

    this.isSalesPersonSearching = true;
    this.subscriptions.push(
      this._userService.GetData('1', searchTerm, { is_primary_agent: true }).subscribe({
        next: (response: any) => {
          this.isSalesPersonSearching = false;
          if (response.status && response.data && response.data.data) {
            this.salesPersonSearchResults = response.data.data;
            this.showSalesPersonDropdown = this.salesPersonSearchResults.length > 0;
          } else {
            this.salesPersonSearchResults = [];
            this.showSalesPersonDropdown = false;
          }
        },
        error: (error: any) => {
          this.isSalesPersonSearching = false;
          console.error('Error searching sales persons:', error);
          this.salesPersonSearchResults = [];
          this.showSalesPersonDropdown = false;
        }
      })
    );
  }

  selectSalesPerson(salesPerson: any): void {
    this.selectedSalesPerson = salesPerson;
    this.salesPersonSearchTerm = this.getSalesPersonDisplayName(salesPerson);
    this.showSalesPersonDropdown = false;
    this.salesPersonSearchResults = [];
    this.filters.sales_person = salesPerson._id;
  }

  clearSalesPersonSearch(): void {
    this.salesPersonSearchTerm = '';
    this.selectedSalesPerson = null;
    this.showSalesPersonDropdown = false;
    this.salesPersonSearchResults = [];
    this.filters.sales_person = '';
  }

  getSalesPersonDisplayName(salesPerson: any): string {
    if (salesPerson.name && salesPerson.company) {
      return `${salesPerson.name}, ${salesPerson.company}`;
    }
    return `${salesPerson.name || ''} ${salesPerson.last_name || ''}`.trim() || salesPerson.email || 'Unknown Sales Person';
  }

  // Setup ship search debounce method
  private setupShipSearchDebounce(): void {
    this.shipSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.searchShips(searchTerm);
    });
  }

  // Ship search methods
  onShipSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.shipSearchTerm = target.value;
    this.selectedShip = null;
    this.shipSearchSubject.next(this.shipSearchTerm);
    this.showShipDropdown = true;
  }

  onShipInputFocus(): void {
    if (this.shipSearchResults.length > 0) {
      this.showShipDropdown = true;
    }
  }

  onShipInputBlur(): void {
    setTimeout(() => {
      this.showShipDropdown = false;
    }, 200);
  }

  private searchShips(searchTerm: string): void {
    if (!searchTerm || searchTerm.length < 2) {
      this.shipSearchResults = [];
      this.showShipDropdown = false;
      return;
    }

    this.isShipSearching = true;
    this.subscriptions.push(
      this._shipService.GetData('1', searchTerm).subscribe({
        next: (response: any) => {
          this.isShipSearching = false;
          if (response.status && response.data && response.data.data) {
            this.shipSearchResults = response.data.data;
            this.showShipDropdown = this.shipSearchResults.length > 0;
          } else {
            this.shipSearchResults = [];
            this.showShipDropdown = false;
          }
        },
        error: (error: any) => {
          this.isShipSearching = false;
          console.error('Error searching ships:', error);
          this.shipSearchResults = [];
          this.showShipDropdown = false;
        }
      })
    );
  }

  selectShip(ship: any): void {
    this.selectedShip = ship;
    this.shipSearchTerm = ship.name;
    this.showShipDropdown = false;
    this.shipSearchResults = [];
    this.filters.ship_name_id = ship._id;
  }

  clearShipSearch(): void {
    this.shipSearchTerm = '';
    this.selectedShip = null;
    this.showShipDropdown = false;
    this.shipSearchResults = [];
    this.filters.ship_name_id = '';
  }

  getShipDisplayName(ship: any): string {
    return `${ship.name} - ${ship.company || ''} (${ship.voyage_no || ''})`;
  }

  canView(permission:string){
    return this.loggedInUser?.role_complete?.is_admin || this.loggedInUser?.role_complete?.permissions?.['vehicle-manager']?.[permission];
  }
}
